var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
import { messageApi, fetcher } from '@xmtp/proto';
import { buildUserPrivateStoreTopic } from '../utils';
const b64Decode = fetcher.b64Decode;
export default class NetworkStore {
    constructor(client) {
        this.client = client;
    }
    // Returns the first record in a topic if it is present.
    get(key) {
        var e_1, _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                for (var _b = __asyncValues(this.client.queryIterator({ contentTopics: [this.buildTopic(key)] }, {
                    pageSize: 10,
                    direction: messageApi.SortDirection.SORT_DIRECTION_DESCENDING,
                })), _c; _c = yield _b.next(), !_c.done;) {
                    const env = _c.value;
                    if (!env.message)
                        continue;
                    try {
                        const bytes = b64Decode(env.message.toString());
                        return Buffer.from(bytes);
                    }
                    catch (e) {
                        console.log(e);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) yield _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return null;
        });
    }
    set(key, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const keys = Uint8Array.from(value);
            yield this.client.publish([
                {
                    contentTopic: this.buildTopic(key),
                    message: keys,
                },
            ]);
        });
    }
    setAuthenticator(authenticator) {
        this.client.setAuthenticator(authenticator);
    }
    buildTopic(key) {
        return buildUserPrivateStoreTopic(key);
    }
}
//# sourceMappingURL=PrivateTopicStore.js.map